if($('.id--17').length){
    $(document).ready(function () {
        $('.co-contact-information').append('<div class="form-group hide"><label for="order_additional_field_01_name">Id zákazníka</label><input name="varchar1" type="text" value="" id="order_additional_field_01_name" class="form-control"></div>')
        const customerData = getShoptetDataLayer('customer');
        if (!customerData || !customerData.guid) {
            console.warn('Zákazník není přihlášen nebo GUID není dostupný.');
            return;
        }
        const guid = customerData.guid;
        $.ajax({
            url: 'https://php.shopcode.cz/api/siruparna/get-customer.php',
            method: 'GET',
            data: { guid: guid },
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    console.error('Chyba:', data.error);
                    return;
                }
                $('input#order_additional_field_01_name').val(data.remark || '')
                
    
               
            },
            error: function (xhr, status, error) {
                console.error('AJAX chyba:', error);
            }
        });
    });
}